module.exports = __webpack_public_path__ + "img/petstairs35.5a357df6.jpg";